import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import DashboardLayout from "../../../components/DashboardLayout";
import { RoutePaths } from "../../../utility/RoutePaths";

const OnlinePaymentResultPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  const classId = searchParams.get("classId");
  const seminarId = searchParams.get("seminarId");
  const courseId = searchParams.get("courseId");
  const date = searchParams.get("date");
  const resultIndicator = searchParams.get("resultIndicator");

  useEffect(() => {
    const successIndicator = sessionStorage.getItem("paymentSuccessIndicator");
    console.log("Result Indicator:", resultIndicator);
    console.log("Success Indicator:", successIndicator);

    // if (!resultIndicator) {
    //   setStatus("cancelled");
    // } else if (successIndicator && resultIndicator === successIndicator) {
    //  setStatus("success");
    // } else {
    //   setStatus("failed");
    // }

    if (successIndicator) {
      setStatus("success");
    } else {
      setStatus("failed");
    }

    sessionStorage.removeItem("paymentSuccessIndicator");
    sessionStorage.removeItem("paymentClassId");
    sessionStorage.removeItem("paymentDate");
  }, [resultIndicator]);

  const handleContinue = () => {
    if (classId) {
      navigate(`${RoutePaths.STUDENT_CLASS_DETAILS_PAGE}?classId=${classId}`);
    } else if (seminarId) {
      navigate(`${RoutePaths.STUDENT_SEMINAR_DETAILS_PAGE}?seminarId=${seminarId}`);
    } else if (courseId) {
      navigate(`${RoutePaths.STUDENT_COURSE_DETAILS_PAGE}?courseId=${courseId}`);
    } else {
      navigate(RoutePaths.STUDENT_DASHBOARD_PAGE);
    }
  };

  const handleRetry = () => {
    if (classId && date) {
      navigate(
        `${RoutePaths.STUDENT_CLASS_MONTH_PAYMENT_PAGE}?classId=${classId}&date=${date}`,
      );
    } else if (seminarId) {
      navigate(
        `${RoutePaths.STUDENT_SEMINAR_DETAILS_PAGE}?seminarId=${seminarId}`,
      );
    } else if (courseId) {
      navigate(
        `${RoutePaths.STUDENT_COURSE_DETAILS_PAGE}?courseId=${courseId}`,
      );
    } else {
      navigate(RoutePaths.STUDENT_DASHBOARD_PAGE);
    }
  };

  return (
    <DashboardLayout title="Payment Result" subtitle="">
      <div className="flex justify-center items-center py-12">
        <div className="bg-white rounded-lg shadow-md p-10 max-w-md w-full text-center">
          {status === "success" && (
            <>
              <div className="flex justify-center mb-4">
                <div className="bg-green-100 rounded-full p-4">
                  <svg
                    className="w-12 h-12 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">
                Payment Successful
              </h2>
              <div className="flex flex-col justify-between mt-4 mb-6">
                <p className="text-gray-600">
                  Your payment record verification is pending. This will take
                  few minutes. If you have any questions, please contact
                  support.
                </p>
                <p className="text-gray-600 mt-2">
                  ඔබගේ ගෙවීම් වාර්තා සත්‍යාපනය පොරොත්තුවෙන් පවතී. මෙයට මිනිත්තු
                  කිහිපයක් ගතවනු ඇත. ඔබට කිසියම් ප්‍රශ්නයක් ඇත්නම්, කරුණාකර සහාය
                  අමතන්න.
                </p>
              </div>
              <button
                onClick={handleContinue}
                className="text-sm font-medium px-6 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700"
              >
                Back to Class
              </button>
            </>
          )}

          {status === "failed" && (
            <>
              <div className="flex justify-center mb-4">
                <div className="bg-red-100 rounded-full p-4">
                  <svg
                    className="w-12 h-12 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Payment Failed
              </h2>
              <p className="text-gray-600 mb-6">
                Your payment could not be completed. Please try again.
              </p>
              <div className="flex justify-center gap-4">
                <button
                  onClick={handleRetry}
                  className="text-sm font-medium px-6 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700"
                >
                  Try Again
                </button>
                <button
                  onClick={handleContinue}
                  className="text-sm font-medium px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                >
                  Cancel
                </button>
              </div>
            </>
          )}

          {status === "cancelled" && (
            <>
              <div className="flex justify-center mb-4">
                <div className="bg-yellow-100 rounded-full p-4">
                  <svg
                    className="w-12 h-12 text-yellow-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Payment Cancelled
              </h2>
              <p className="text-gray-600 mb-6">
                You cancelled the payment. No charges were made.
              </p>
              <div className="flex justify-center gap-4">
                <button
                  onClick={handleRetry}
                  className="text-sm font-medium px-6 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700"
                >
                  Try Again
                </button>
                <button
                  onClick={handleContinue}
                  className="text-sm font-medium px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                >
                  Cancel
                </button>
              </div>
            </>
          )}

          {status === null && <p className="text-gray-500">Processing...</p>}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default OnlinePaymentResultPage;
